import { Controller } from "@hotwired/stimulus"
import { searchTakeoverScrollLock } from "../src/search_takeover_scroll_lock"

// Manages the shelf search takeover and keeps it synchronized with the shared
// shelf filters form.
export default class extends Controller {
  static targets = ["desktopField", "filterField", "input", "overlay", "queryAction"]
  static values = { term: String }

  connect() {
    this.appliedQuery = this.termValue
    this.scrollLock = searchTakeoverScrollLock()
    this.scrollLock.closeSearch = () => this.close()
  }

  disconnect() {
    clearTimeout(this.desktopSearchTimeout)
    cancelAnimationFrame(this.openFrame)
    this.scrollLock.destroy()
  }

  open() {
    if (!this.overlayTarget.classList.contains("hidden")) return

    this.inputTarget.value = this.appliedQuery
    this.updateQueryActions()
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")

    this.openFrame = requestAnimationFrame(() => {
      this.scrollLock.lockBodyScroll()
      this.inputTarget.focus()
    })
  }

  close() {
    cancelAnimationFrame(this.openFrame)
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("flex")
    this.inputTarget.value = this.appliedQuery
    this.inputTarget.blur()
    this.scrollLock.unlockBodyScroll()
  }

  clearDraft() {
    this.inputTarget.value = ""
    this.updateQueryActions()
    this.inputTarget.focus()
  }

  updateQueryActions() {
    const hidden = this.inputTarget.value.length === 0
    this.queryActionTargets.forEach((button) => button.classList.toggle("hidden", hidden))
  }

  submit(event) {
    event.preventDefault()

    const term = this.inputTarget.value.trim()
    this.appliedQuery = term
    this.close()
    this.applyTerm(term)
  }

  clear() {
    this.appliedQuery = ""
    this.inputTarget.value = ""
    this.updateQueryActions()
    this.applyTerm("")
  }

  searchDesktop(event) {
    const term = event.currentTarget.value

    clearTimeout(this.desktopSearchTimeout)
    this.desktopSearchTimeout = setTimeout(() => this.applyTerm(term), 300)
  }

  applyTerm(term) {
    this.appliedQuery = term
    this.filterFieldTarget.value = term

    if (this.hasDesktopFieldTarget) {
      this.desktopFieldTarget.value = term
    }

    this.filterFieldTarget.form.requestSubmit()
  }
}
